import { instanceOfResolution } from 'data/Resolution';
import { Middleware } from 'redux';
import { getStoreState } from 'state/Store';
import { isRunningInProduction } from 'utils';
import { reportBFError } from '../../utils/Tracker';

let didBreak = false;

export const testSavingMiddleware: Middleware =
  (store: any) => (next: Function) => (action: any) => {
    next(action);

    if (didBreak) {
      return;
    }
    setTimeout(() => {
      if (didBreak) {
        return;
      }
      const { id, resolution } = getStoreState().flyer;
      if (id !== null && (!resolution || !instanceOfResolution(resolution))) {
        didBreak = true;
        const msg = 'Flyer got corrupted after event ' + action.type;
        reportBFError(new Error(msg));
        if (!isRunningInProduction()) {
          alert(msg);
        }
      }
    }, 100);
  };



// WEBPACK FOOTER //
// ./src/state/side-effects/testSaving.ts